// extracted by mini-css-extract-plugin
module.exports = {"message":"SizeError_message__bIlpf"};